var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 139,
    height: 150,
    viewBox: "0 0 139 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_2",
    "data-name": 2,
    transform: "translate(-269 -2871.996)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_455",
    "data-name": "Group 455",
    transform: "translate(8 -0.004)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    cx: 69.5,
    cy: 69.5,
    r: 69.5,
    transform: "translate(261 2880)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_13",
    "data-name": "Ellipse 13",
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    transform: "translate(322 2872)",
    fill: "#f36822"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_14",
    "data-name": "Ellipse 14",
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    transform: "translate(344 3007)",
    fill: "#1c3557"
  })), /*#__PURE__*/React.createElement("g", {
    id: "doctor",
    transform: "translate(311.912 2906.342)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4645",
    "data-name": "Path 4645",
    d: "M54.514,40.625a6.368,6.368,0,0,0-5.393-5.393V33.579A8.029,8.029,0,0,0,41.389,25.3a8.06,8.06,0,0,0-7.732,8.03h.053l-.053.009V51.267c0,5.731-4.284,10.385-9.551,10.385s-9.551-4.66-9.551-10.385V49.714c1.319,0,2.729-.956,2.729-3.639V43.788C23.122,42.3,27.29,37.282,27.29,31.6V29.7H25.47l-.038-11.839A4.553,4.553,0,0,0,21.69,13.41a2.714,2.714,0,1,0-.062,1.855,2.729,2.729,0,0,1,1.982,2.6L23.651,29.7H21.832v1.923A7.234,7.234,0,0,1,16.6,38.412a8.271,8.271,0,0,1-5,0,7.23,7.23,0,0,1-5.225-6.787V29.7H3.639V17.876a2.729,2.729,0,0,1,2.019-2.623A2.742,2.742,0,1,0,5.6,13.405a4.548,4.548,0,0,0-3.782,4.471V29.7H0v1.892c0,5.69,4.171,10.7,10.006,12.194v2.288c0,2.683,1.41,3.639,2.729,3.639v1.553c0,6.731,5.1,12.2,11.371,12.2s11.371-5.479,11.371-12.2V33.384a6.225,6.225,0,0,1,5.913-6.261A6.21,6.21,0,0,1,47.3,33.582v1.651a6.368,6.368,0,1,0,7.212,5.393ZM19.1,15.147a.91.91,0,1,1,.91-.91A.91.91,0,0,1,19.1,15.147ZM8.187,13.328a.91.91,0,1,1-.91.91A.91.91,0,0,1,8.187,13.328ZM1.819,31.594v-.073H4.548v.1a9.038,9.038,0,0,0,6.493,8.517,10.122,10.122,0,0,0,6.111,0,9.04,9.04,0,0,0,6.5-8.517v-.1H25.47v.073c0,5.06-3.9,9.513-9.278,10.59a12.976,12.976,0,0,1-3.838.188,11.882,11.882,0,0,1-1.256-.19C5.72,41.107,1.819,36.654,1.819,31.594ZM12.735,47.9c-.819,0-.91-1.274-.91-1.819v-1.93c.073.009.147.013.221.02.091.01.182.017.273.025.43.038.864.064,1.3.065h.045c.437,0,.87-.026,1.3-.065.091-.008.187-.015.281-.025.072-.008.146-.011.218-.02v1.93c0,.546-.091,1.819-.91,1.819Zm35.477-1.819a4.548,4.548,0,1,1,4.548-4.548A4.548,4.548,0,0,1,48.212,46.076Z",
    transform: "translate(0 3.516)",
    fill: "#6c6a6c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_514",
    "data-name": "Group 514",
    transform: "translate(53.854 44.225)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_513",
    "data-name": "Group 513"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4646",
    "data-name": "Path 4646",
    d: "M403.231,251.515a3.231,3.231,0,1,0,3.231,3.231A3.231,3.231,0,0,0,403.231,251.515Zm0,4.308a1.077,1.077,0,1,1,1.077-1.077A1.077,1.077,0,0,1,403.231,255.823Z",
    transform: "translate(-400 -251.515)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.59f30e74edd98a8421f5deafdb62aacf.svg";
export { ForwardRef as ReactComponent };